import React from 'react';
import { Container, Box } from '@mui/material';
import { Header } from './header';
import { Props } from '../../shared.interfaces';
import imgBg from '../../../assets/images/img_bg.png';
import { ContainerTop } from '../../../styles/globalStyles';

export const Layout = ({ children }: Props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box
        sx={{
          flexGrow: 1,
          backgroundImage: `url(${imgBg})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <ContainerTop maxWidth="lg">{children}</ContainerTop>
      </Box>
    </Box>
  );
};
